import { graphql, navigate } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";
import CountriesPopup from "../components/CountriesPopup";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "../styles/index.css";
import "../styles/default.scss";
import Language from "../components/Language";

const Legal = ({ data }) => {
  const { site = {}, logo = {}, altLogo = {}, mobileLogo = {} } = data || {},
    { siteMetadata = {} } = site;
  const { t, i18n } = useTranslation();
  const { childImageSharp = {} } = logo,
    { fixed = {} } = childImageSharp,
    { childImageSharp: altLogoChild = {} } = altLogo,
    { fixed: altLogoFixed = {} } = altLogoChild,
    { childImageSharp: mobileLogoChild } = mobileLogo,
    { fixed: mobileLogoFixed } = mobileLogoChild;
  const handleLinkClick = (link) => {
    navigate("/", {
      state: { activeElement: link },
    });
  };
  return (
    <div className="layout-container">
      <Header
        siteMetadata={siteMetadata}
        lang={i18n.language}
        logo={fixed}
        altLogo={altLogoFixed}
        mobileLogo={mobileLogoFixed}
        showLanguages={false}
        onLinkClick={handleLinkClick}
      />
      <Language />
      <div className="legal-data">
        <h1>Imprint</h1>
        <h2>Editorial Responsibility</h2>
        <p>Delivery Hero SE</p>
        <p>Information according to § 5 TMG (Telekommunikationsgesetz)</p>
        <p>Oranienburger Straße 70</p>
        <p>10117 Berlin</p>
        <p>Germany</p>
        <h2>Management Board</h2>
        <p>Niklas Östberg (CEO)</p>
        <p>Emmanuel Thomassin (CFO)</p>
        <p>Pieter-Jan Vandepitte (COO)</p>
        <h2>Supervisory Board</h2>
        <p>Dr. Martin Enderle (Chairman)</p>
        <h2>Contact</h2>
        <p>Phone: +49 (30) 54 44 59 000</p>
        <p>Email: hello@noahsgreenkitchen.com</p>
        <br />
        <p>
          Registergericht/district court: Amtsgericht Berlin-Charlottenburg /
          Local Court Charlottenburg Berlin
        </p>
        <p>Handelsregister/Commercial Register: HRB 198015 B</p>
        <p>Umsatzsteuer-Identifikationsnummer/ VAT-ID No.: DE 815294913</p>
        <p>
          Responsible for the content according to § 55 RStV
          (Rundfunkstaatsvertrag / Interstate Broadcasting Agreement): Niklas
          Östberg
        </p>
      </div>
      <Footer />
      <CountriesPopup />
    </div>
  );
};

export default Legal;

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        siteUrl
      }
    }
    logo: file(relativePath: { eq: "logo.png" }) {
      childImageSharp {
        fixed(width: 100, height: 64) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    mobileLogo: file(relativePath: { eq: "logo.png" }) {
      childImageSharp {
        fixed(width: 82, height: 56) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    altLogo: file(relativePath: { eq: "alt_logo.png" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;
